module.exports = __webpack_public_path__ + "img/Person.3899ca75.jpg";